import BulkPaymentLinkHeader from './BulkPaymentLinkHeader';
import BulkPaymentLinkTable from './BulkPaymentLinkTable';
import React from 'react';

import './bulkpaymentlink.scss';

const BulkPaymentLink = () => {
    return (
        <div className="bulk-payment-link-wrapper">
            <BulkPaymentLinkHeader />
            <BulkPaymentLinkTable />
        </div>
    );
};

export default BulkPaymentLink;
